import { Injectable } from '@angular/core';
import { EpHttpService } from '../../services/epHttpService/epHttp.service';
import { EpEnvironmentService } from 'src/app/shared/services/epEnvironmentService/ep-environment.service';

@Injectable({
  providedIn: 'root'
})
export class EpPopupRenewalService {

  constructor(private epHttpService: EpHttpService) { }

  getTermCodes() {
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/lookup/termcodes`;
    return this.epHttpService.request('GET', url);
  }

  getDeclineRequest(quoteid) {
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/quotes/${quoteid}/decline-request`;
    return this.epHttpService.request('GET', url);
  }

  postDeclineRequest(quoteid , body: any) {
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/quotes/${quoteid}/decline-request`;
    return this.epHttpService.request('POST', url, { body });
  }
}
